import { IController } from 'angular';
import * as _ from 'lodash';
import { ImCourseDiff } from 'Src/ng2/shared/services/im-models/im-course-diff';
import { ImGapPlan } from 'Src/ng2/shared/services/im-models/im-gap-plan';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { IGapPlan } from '../../../../../../../../ng2/shared/typings/interfaces/gap-plan.interface';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class MonitorProgramChangesStepCtrl implements IController {
  static $inject: string[] = [
    '$scope',
    'ImSchool',
    'CourseDiff',
    'GapPlan',
    'WizardUtils',
    'ImGapPlan',
    'ImCourseDiff',
  ];

  public unFlattenedStudents;
  public currentCourseDiffs;
  public school;
  public currentTermYear;
  public plurals;
  public buckets;
  public courseAdds;
  public courseDrops;
  public courseAddsAndDrops;
  public countGapPlansForThisTerm;
  public countGapPlansForFutureTerm;

  constructor(
    public $scope,
    private ImSchool: ImSchool,
    private CourseDiff: any,
    private GapPlan: any,
    private WizardUtils: WizardUtils,
    private imGapPlan: ImGapPlan,
    private imCourseDiff: ImCourseDiff,
  ) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.unFlattenedStudents = this.WizardUtils.getAllUnflattenedStudents();
    this.school = this.WizardUtils.getCurrentSdcSchool();
    this.currentTermYear = this.ImSchool.getCurrentTermYear(this.school);
    const courseDiffFilter = {
      termYear: this.currentTermYear,
      status: 'PENDING',
    };
    this.buckets = this.generateFilteredStudentIdBuckets();
    this.courseAddsAndDrops = this.buckets.courseDiffs;
    this.courseAdds = this.imCourseDiff.filterForAddCourseDiffs(this.courseAddsAndDrops, courseDiffFilter);
    this.courseDrops = this.imCourseDiff.filterForDropCourseDiffs(this.courseAddsAndDrops, courseDiffFilter);
    this.countGapPlansForThisTerm = this.buckets.gapPlansForThisTerm.length;
    this.countGapPlansForFutureTerm = this.buckets.gapPlansForFutureTerm.length;

    this.plurals = {
      s: {
        0: 's',
        1: '',
        other: 's',
      },
      is: {
        0: 's are',
        1: ' is',
        other: 's are',
      },
      has: {
        0: 's have',
        1: ' has',
        other: 's have',
      },
    };
  }

  private generateFilteredStudentIdBuckets() {
    const courseDiffs = [];
    const gapPlansForThisTerm = [];
    const gapPlansForFutureTerm = [];
    _.each(this.unFlattenedStudents, (student: any) => {
      const { join_activeGapPlans, join_pendingCourseDiffs } = student;
      _.each(join_activeGapPlans, _activeGapPlan => {
        const gapPlan: IGapPlan = new this.GapPlan(_activeGapPlan);
        if (this.imGapPlan.isActiveForCurrentTerm(gapPlan, this.currentTermYear)) {
          gapPlansForThisTerm.push(gapPlan);
        } else if (this.imGapPlan.isActiveForFutureTerm(gapPlan, this.currentTermYear)) {
          gapPlansForFutureTerm.push(gapPlan);
        }
      });
      _.each(join_pendingCourseDiffs, diff => courseDiffs.push(diff));
    });
    return {
      courseDiffs,
      gapPlansForThisTerm,
      gapPlansForFutureTerm,
    };
  }
}
